import { useCallback, useState } from 'react';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { NAMES_REGEX } from '../../../Utils/Misc/RegEx';

const socialNameSchema = yup.object({
  firstName: yup
    .string()
    .trim()
    .matches(NAMES_REGEX, 'No se permiten números ni caracteres especiales')
    .max(80, 'Máximo 80 caracteres')
    .required('Ingresa tu nombre'),
  lastName: yup
    .string()
    .trim()
    .matches(NAMES_REGEX, 'No se permiten números ni caracteres especiales')
    .max(80, 'Máximo 80 caracteres')
    .required('Ingresa tus apellidos')
});

const useSocialRegistrationDialog = isUpdateUserPath => {
  const { register, reset, formState, errors, getValues } = useForm({
    resolver: yupResolver(socialNameSchema),
    mode: 'all',
    defaultValues: { firstName: '', lastName: '' }
  });

  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [newUserParams, setNewUserParams] = useState({});

  const openRegistrationDialog = useCallback(
    (key, params, clearFn) => {
      const nameRequired =
        !isUpdateUserPath && (!params.firstName || !params.lastName);
      if (nameRequired) {
        reset({ firstName: params.firstName, lastName: params.lastName });
      }
      setConfirmationDialog(true);
      setNewUserParams({ [key]: params, nameRequired });
      clearFn(null);
    },
    [reset, isUpdateUserPath]
  );

  const applyDialogNames = useCallback(
    params => {
      if (!newUserParams.nameRequired) {
        return params;
      }
      const values = getValues();
      return {
        ...params,
        firstName: values.firstName.trim(),
        lastName: values.lastName.trim()
      };
    },
    [newUserParams, getValues]
  );

  return {
    register,
    errors,
    formState,
    getValues,
    reset,
    confirmationDialog,
    setConfirmationDialog,
    newUserParams,
    setNewUserParams,
    openRegistrationDialog,
    applyDialogNames
  };
};

export default useSocialRegistrationDialog;
